import localforage from 'localforage'

let localforageLegalNotes = localforage.createInstance({
  name: 'qm-survey-webapp',
  storeName: 'legal-notes'
})

let initialState = {
  all: []
}

let state = initialState

const getters = {
  getAllLegalNotes: state => state.all
}

const actions = {
  importLegalNotes ({ commit }, legalNotes) {
    return new Promise((resolve, reject) => {
      commit('clearLegalNotesState')
      legalNotes.forEach((legalNote) => {
        localforageLegalNotes.setItem(String(legalNote['language-code']), legalNote.value)
      })
      commit('setLegalNotesToState', legalNotes)
      resolve()
    })
  },
  loadAllLegalNotes ({ commit }) {
    return new Promise((resolve, reject) => {
      let legalNotes = []
      localforageLegalNotes.getItems().then((results) => {
        Object.keys(results).forEach((key) => {
          let value = results[key]
          legalNotes.push({'language-code': key, 'value': value})
        })
        commit('setLegalNotesToState', legalNotes)
        resolve()
      })
    })
  },
  clearLegalNotesStorage ({ commit }) {
    return new Promise((resolve, reject) => {
      localforageLegalNotes.clear().then(() => {
        commit('clearLegalNotesState')
        resolve()
      })
    })
  }
}

// mutations
const mutations = {
  setLegalNotesToState (state, legalNotes) {
    state.all = legalNotes
  },
  clearLegalNotesState (state) {
    state = initialState
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}




// WEBPACK FOOTER //
// ./src/store/modules/legalNotes.js